// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4bd99dd1","732":"bb0ad4de","946":"ca6dd61c"}[chunkId] + ".chunk.js";
};